import React from 'react';

export default function PayoutPolicy() {
  return (
    <div className="space-y-8 bg-white min-h-screen p-8">
      <h1 className="text-3xl font-bold text-purple-400 text-center">Payout Policy</h1>

      <p className="text-gray-700">
        Million2Trillion (M2T) provides payout services for verified content creators, educators, signal providers, affiliates, and service vendors.
      </p>

      <ul className="list-disc text-gray-700 space-y-4 pl-6">
        <li>All payouts require full KYC verification and tax documentation as per jurisdictional rules.</li>
        <li>Minimum payout thresholds may apply depending on your account type and payout method.</li>
        <li>Payments will be processed via approved payout partners (bank transfer, Stripe, Wise, Payoneer, etc.).</li>
        <li>Standard payout cycles are weekly or bi-weekly depending on payout volume and account standing.</li>
        <li>M2T reserves the right to hold payouts for investigation if any fraudulent, chargeback, or compliance flags are triggered.</li>
        <li>All payout fees, bank charges, and currency conversion costs are borne by the receiver unless otherwise stated.</li>
      </ul>

      <p className="text-gray-500 italic">
        By participating in our payout program, you agree to comply with international AML (Anti-Money Laundering) and taxation rules applicable to your region.
      </p>
    </div>
  );
}
